import React from "react";
import { pageHeaderWrap, headElement, textElement} from "./pageHeader.module.css";

const PageHeader = ({ head, text }) => {
  return (
    <div className={pageHeaderWrap}>
      <h3 className={headElement}>{head}</h3>
      <p className={textElement}>{text}</p>
    </div>
  );
};

export { PageHeader }
